// src/layouts/Dashboardlayout.jsx

import React, { useState } from 'react';
import { Outlet, Navigate, useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import SideDrawer from '../components/SideDrawer/SideDrawer';
import Footer from '../components/Footer/Footer';
import { useAuth } from '../hooks/useAuth';
import { logOut } from '../firebase';

export default function DashboardLayout() {
  const { user, authLoading } = useAuth();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  // Keep the spinner/loading state seamless
  if (authLoading) return null;

  // Protect all routes inside this layout: kick to landing if not logged in
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Handle navigation from the drawer/header
  const handleNavigate = (view) => {
    // If you eventually create separate routes for profile/settings, 
    // you would change this to navigate(`/users/${view}`)
    navigate('/users', { state: { targetView: view } });
    setDrawerOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="app-wrapper">
      <Header 
        onOpenDrawer={() => setDrawerOpen(true)} 
        onNavigate={handleNavigate}
        user={user}
        onLogout={logOut}
      />
      
      <SideDrawer 
        open={drawerOpen} 
        onClose={() => setDrawerOpen(false)} 
        onNavigate={handleNavigate}
        user={user}        
        onLogout={logOut}  
      />
      
      <main className="main-container">
        {/* EVERYTHING inside the active route renders inside this Outlet */}
        <Outlet context={{ user }} />
      </main>

      <Footer onNavigate={handleNavigate} />
    </div>
  );
}